import React from 'react';
import { createRoot } from 'react-dom/client';
import './theme.css';
// Capa visual de Johnny (.jny-*). SIEMPRE despues de theme.css: sus clases
// pisan a las genericas (.jny-btn sobre .action-btn) por orden de cascada.
import './johnny.css';
import './alta.css';
import './operator.css';
import './diagnostico.css';
// La pestaña «Seguimiento» (solo donde el servidor la enciende).
import './seguimiento.css';
import { App } from './App.js';

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');
createRoot(root).render(
  <React.StrictMode>
    {import.meta.env.VITE_FLUXO_DEMO && <aside className="op-demo-banner" aria-label="Demo local">Demo local · Datos sintéticos. Las acciones se simulan y no envían correos ni generan cobros reales.</aside>}
    <App />
  </React.StrictMode>,
);
